import type { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";

const INSTANCE_MESH_CLASS = "InstancedMesh";
const VISIBLE_ALPHA_THRESHOLD = 0.001;

function clampVisibility(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.max(0, Math.min(1, value));
}

export function supportsMeshVisibilityAlpha(mesh: AbstractMesh): boolean {
  return mesh.getClassName() !== INSTANCE_MESH_CLASS;
}

export function setMeshVisibility(mesh: AbstractMesh, value: number): void {
  const clamped = clampVisibility(value);
  if (supportsMeshVisibilityAlpha(mesh)) {
    mesh.visibility = clamped;
    return;
  }

  // Babylon warns and ignores `visibility` on InstancedMesh. Shared GLB
  // instances still need to hide/reveal, so use their binary render flag.
  mesh.isVisible = clamped > VISIBLE_ALPHA_THRESHOLD;
}
